import { assetUrl, homeUrl } from "@/lib/assets";
"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function Overview() {
  return <section id="historicaloverview" data-nav="light" className="acad-about-overview w-full bg-muted/20 py-12 md:py-16 lg:py-20">
      <div className="page-container">
        <div className="acad-about-overview-card bg-card text-card-foreground rounded-2xl md:rounded-3xl border border-border/60 shadow-sm overflow-hidden p-6 sm:p-8 md:p-12 lg:p-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 lg:gap-16 items-center">
            {/* Left Column: Historical Photo */}
            <div className="acad-about-overview-media acad-reveal lg:col-span-5 xl:col-span-6">
              <div className="relative overflow-hidden rounded-xl md:rounded-2xl border border-border shadow-md bg-muted aspect-4/5 sm:aspect-square lg:aspect-4/5 max-w-md mx-auto lg:max-w-none">
                <img alt="Primeros líderes de las Asambleas de Dios" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale contrast-110" src={assetUrl("36918933_1852040114852363_672322566924271616_n.jpg")} />
              </div>
            </div>

            {/* Right Column: Narrative & Details */}
            <div className="acad-about-overview-copy acad-reveal acad-reveal-delay lg:col-span-7 xl:col-span-6 flex flex-col justify-center">
              {/* Heading */}
              <div className="mb-6 md:mb-8">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-default font-extrabold uppercase tracking-tight text-foreground leading-[1.15]">
                  <span><span className="!font-semibold">ASAMBLEAS DE</span></span>{" "}
                  
                  <br />
                  <span className="flex flex-wrap items-center gap-3">
                    <span><span className="!font-semibold">DIOS DESDE</span></span>
                    <Badge variant="destructive" className="rounded-full px-4 py-1 text-xl sm:text-2xl md:text-3xl font-extrabold tracking-normal">1940</Badge>
                  </span>
                </h2>
              </div>

              {/* Text content */}
              <div className="space-y-4 md:space-y-6 text-muted-foreground text-base sm:text-lg leading-relaxed">
                <div>
                  <p className="font-semibold text-foreground">Los primeros pasos (década de 1940)</p>
                  <p>A mediados de la década de 1940, el mensaje del avivamiento pentecostal comenzó a echar raíces en suelo costarricense. Los inicios de la obra no estuvieron marcados por grandes templos o recursos abundantes, sino por corazones profundamente dispuestos. Los primeros cultos cobraron vida en casas humildes y pequeños locales, donde grupos de creyentes se reunían con un hambre genuina por la Palabra y la presencia de Dios.</p>
                </div>
                <div>
                  <p className="font-semibold text-foreground">La primera congregación y consolidación (1950)</p>
                  <p>La primera iglesia de las Asambleas de Dios en Costa Rica nació como fruto del trabajo abnegado entre los primeros misioneros y los creyentes locales que abrazaron la visión. Hacia la década de 1950, la obra tomó un impulso decisivo con el establecimiento del Instituto Bíblico (1952), destinado a capacitar a los primeros pastores y líderes nacionales.</p>
                </div>
              </div>

              {/* Action Button */}
              <div className="mt-8 md:mt-10">
                <Button asChild className="rounded-full bg-foreground text-background hover:bg-foreground/90 font-semibold px-6 py-5 text-sm uppercase tracking-wider transition-transform hover:scale-[1.02]">
                  <Link to={homeUrl("creencias/")} className="inline-flex items-center gap-2">
                    <span>CONOCER MÁS</span>
                    <ArrowUpRight className="size-4" aria-hidden="true" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
